import RandomizeButton from './randomize-button';

export default RandomizeButton;
